import { classNames } from "shared/lib/classNames/classNames"
import cls from "./StackIcon.module.scss"

interface StackIconProps {
    icon: string,
    className?: string
}

export const StackIcon = (props: StackIconProps) => {
    const { icon, className } = props

    return (
        <img className={classNames(cls.icon, {}, [className])} src={icon} alt="icon"></img>
    )
}

